import React from 'react';

const ATag = ({ children, ...props }) => <a {...props}>{children}</a>;
export default ATag;
